// Make the query to the autocomplete arrays
const filterObjectToQuery = documents => (documents.map(document => (document.value)).join(','));

export default filterObjectToQuery;
